import { render } from "./LanguageVariables.vue?vue&type=template&id=3ccb2fef"
import script from "./LanguageVariables.vue?vue&type=script&lang=ts"
export * from "./LanguageVariables.vue?vue&type=script&lang=ts"

import "./LanguageVariables.vue?vue&type=style&index=0&id=3ccb2fef&lang=scss"
script.render = render

export default script